import gql from 'graphql-tag';

const ACKNOWLEDGE_SERVICE_RUN_BRIEF = gql`
	mutation acknowledgeServiceRunBriefMutation($id: ID!, $adminTraining: Boolean) {
		acknowledgeServiceRunBrief(id: $id, adminTraining: $adminTraining) {
			id
			briefAcknowledgedAt
			briefAcknowledgedBy
		}
	}
`;

export default ACKNOWLEDGE_SERVICE_RUN_BRIEF;
